import { NotificationRepository } from "@core/data/repositories/notification.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class MarkNotificationReadUseCase {
    constructor(
        @inject(NotificationRepository)
        private readonly repository: NotificationRepository,
    ) {}

    execute(id: number): Promise<Either<FallbackError, true>> {
        return this.repository.markRead(id);
    }
}
